import { useUserWithCompany } from '@app/hooks/useUserWithCompany';
import { UserTopicApplicationsQuestionnaires } from '@dieterApi/user/useUserQuery';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { useState } from 'react';
import { AddPartnerMenu } from './AddPartnerMenu';
import { PartnerData } from './PartnerListEntry';

interface AddPartnerButtonProps {
  topic: UserTopicApplicationsQuestionnaires;
  setNewEntry: (newEntry: PartnerData) => void;
}

export function AddPartnerButton({ topic, setNewEntry }: AddPartnerButtonProps) {
  const { user } = useUserWithCompany();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        startIcon={<AddIcon />}
        disabled={user?.isReadOnly}
        data-testid="button-add-partner"
        size="small"
      >
        Hinzufügen
      </Button>
      <AddPartnerMenu topic={topic} anchorEl={anchorEl} handleClose={handleClose} setNewEntry={setNewEntry} />
    </>
  );
}
